import Image from '@atoms/Image/Image';
import { IFeature } from '@models/IFeature';
import FeatureTextContent from '@molecules/FeatureTextContent/FeatureTextContent';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import classNames from 'classnames';

const FullWidthImageFeature = ({
  title,
  alignment,
  image,
  text,
  preCTA,
  primaryCTA,
  meta,
  anchorId,
}: IFeature) => (
  <section
    className="component-padding bg-black-100 text-white"
    id={`a-${anchorId}`}
  >
    <SoftLoadWrapper>
      {image && (
        <div className="container relative flex w-full flex-col gap-7">
          <div data-epi-property-name={meta?.editHints?.image}>
            <Image image={image} imageClasses="w-full object-cover" />
          </div>

          <div className="top-0 left-0 h-full w-full grid-cols-12 xl:container xl:absolute xl:grid">
            <div
              className={classNames(
                'flex flex-col justify-start gap-7 overflow-hidden lg:gap-4',
                {
                  'col-span-4 col-start-8 justify-start':
                    alignment === 'topRight',
                  'col-span-4 col-start-2 justify-start':
                    alignment === 'topLeft',
                  'col-span-4 col-start-8 justify-end':
                    alignment === 'bottomRight',
                  'col-span-4 col-start-2 justify-end':
                    alignment === 'bottomLeft',
                  'col-span-5 justify-start xl:mt-16':
                    alignment === 'topLeftWithOffset',
                }
              )}
            >
              <FeatureTextContent
                title={title}
                text={text}
                preCTA={preCTA}
                primaryCTA={primaryCTA}
                meta={meta}
              />
            </div>
          </div>
        </div>
      )}
    </SoftLoadWrapper>
  </section>
);

export default FullWidthImageFeature;
